import { render } from "./App.vue?vue&type=template&id=4f900544&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4f900544"

export default script